var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 904 562",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M475.941,236.884C475.664,207.977 470.608,186.621 460.776,172.825C450.946,159.029 436.731,152.22 418.144,152.399C399.552,152.577 385.514,159.657 376.032,173.639C366.545,187.62 361.942,209.069 362.222,237.976L363.162,336.088C363.442,365.163 368.536,386.635 378.453,400.509C388.365,414.389 402.617,421.235 421.208,421.057C439.796,420.879 453.792,413.799 463.198,399.817C472.601,385.836 477.164,364.228 476.884,334.996L475.941,236.884M535.725,326.111C536.167,372.021 526.155,407.116 505.696,431.4C485.235,455.687 457.223,467.999 421.663,468.34C385.936,468.683 357.533,456.913 336.448,433.025C315.365,409.141 304.603,374.245 304.161,328.335L303.387,247.591C302.947,201.845 312.953,166.747 333.415,142.3C353.872,117.853 381.961,105.459 417.689,105.116C453.251,104.775 481.577,116.628 502.663,140.675C523.748,164.721 534.511,199.621 534.949,245.367L535.725,326.111",
    style: {
      fill: "rgb(240,61,95)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.147,468.347C385.131,468.347 357.235,456.575 336.448,433.025C315.365,409.141 304.603,374.245 304.161,328.335L303.387,247.591C303.377,246.607 303.372,245.629 303.372,244.656C303.382,200.341 313.393,166.221 333.415,142.3C353.872,117.853 381.961,105.459 417.689,105.116C418.185,105.111 418.685,105.108 419.179,105.108C454.044,105.108 481.872,116.963 502.663,140.675C523.748,164.721 534.511,199.621 534.949,245.367L535.725,326.111C535.735,327.096 535.74,328.077 535.739,329.055C535.732,373.525 525.716,407.639 505.696,431.4C485.235,455.687 457.223,467.999 421.663,468.34C421.157,468.344 420.649,468.347 420.147,468.347M362.209,235.455C362.209,236.288 362.212,237.129 362.221,237.976L363.163,336.088C363.443,365.163 368.536,386.635 378.453,400.509C388.24,414.212 402.256,421.06 420.503,421.06L421.208,421.057C439.796,420.879 453.792,413.799 463.198,399.817C472.327,386.247 476.892,365.488 476.896,337.545C476.896,336.703 476.892,335.852 476.884,334.996L475.941,236.884C475.664,207.977 470.608,186.621 460.776,172.825C451.071,159.205 437.092,152.395 418.853,152.395C418.616,152.395 418.381,152.396 418.144,152.399C399.552,152.577 385.514,159.657 376.032,173.639C366.824,187.211 362.216,207.819 362.209,235.455",
    style: {
      fill: "rgb(143,90,88)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.887,236.559C509.609,207.651 504.555,186.295 494.721,172.499C484.891,158.703 470.676,151.893 452.088,152.072C433.498,152.251 419.46,159.331 409.978,173.312C400.492,187.295 395.889,208.742 396.167,237.651L397.109,335.763C397.388,364.837 402.481,386.309 412.399,400.184C422.311,414.063 436.563,420.908 455.155,420.729C473.741,420.552 487.739,413.472 497.144,399.492C506.547,385.511 511.111,363.902 510.829,334.671L509.887,236.559ZM569.671,325.785C570.112,371.696 560.1,406.791 539.643,431.073C519.18,455.36 491.168,467.673 455.608,468.013C419.881,468.356 391.478,456.587 370.395,432.699C349.309,408.815 338.548,373.919 338.108,328.008L337.332,247.264C336.892,201.519 346.9,166.42 367.36,141.974C387.817,117.528 415.908,105.134 451.635,104.789C487.196,104.448 515.523,116.301 536.608,140.348C557.695,164.396 568.456,199.295 568.896,245.04L569.671,325.785",
    style: {
      fill: "rgb(237,192,185)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.235,336.143L156.957,340.279L163.207,197.105L161.775,196.557L156.476,206.763L62.236,336.143M215.584,342.837L260.159,344.784L258.097,392.023L213.521,390.076L210.095,468.568L151.469,466.008L154.895,387.518L3.485,380.908L3.599,344.935L164.928,113.2L225.492,115.843L215.584,342.837",
    style: {
      fill: "rgb(240,61,95)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.095,468.568L151.469,466.008L154.895,387.518L192.173,389.145L188.748,467.635L210.095,468.568M258.097,392.023L250.799,391.704L258.097,392.023M40.764,382.536L3.484,380.908L3.599,344.935L164.928,113.2L225.492,115.843L202.207,114.827L40.878,346.563L40.764,382.536M194.236,341.906L99.513,337.771L156.957,340.279L160.736,253.72L193.753,208.39L199.053,198.184L200.485,198.732L194.236,341.905",
    style: {
      fill: "rgb(143,90,88)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.513,337.77L194.236,341.905L200.486,198.732L199.053,198.184L193.753,208.391L99.513,337.771M252.861,344.464L297.437,346.411L295.376,393.651L250.799,391.704L247.372,470.194L188.748,467.636L192.173,389.146L40.764,382.536L40.878,346.563L202.207,114.827L262.769,117.471L252.861,344.464",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.83,358.33L736.193,349.103L722.244,206.472L720.748,206.132L716.938,216.982L641.83,358.33M794.594,343.39L839,339.048L843.603,386.108L799.196,390.451L806.844,468.643L748.442,474.355L740.795,396.163L589.96,410.913L585.014,375.281L712.147,123.16L772.48,117.259L794.595,343.391",
    style: {
      fill: "rgb(240,61,95)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.443,474.355L740.796,396.163L667.479,403.332L777.932,392.529L785.58,470.723L806.845,468.643L748.443,474.355M589.96,410.913L585.014,375.281L712.147,123.16L749.284,119.528L622.151,371.649L627.096,407.283L589.961,410.913M836.335,386.819L843.604,386.108L836.334,386.818M678.968,354.698L691.265,353.496L678.968,354.699M736.193,349.103L727.76,262.873L754.075,213.349L757.884,202.5L759.381,202.84L773.329,345.47L736.193,349.101",
    style: {
      fill: "rgb(143,90,88)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.968,354.699L773.329,345.469L759.381,202.84L757.884,202.5L754.074,213.35L678.968,354.699M831.732,339.759L876.139,335.415L880.741,382.475L836.335,386.819L843.981,465.011L785.58,470.723L777.932,392.529L627.096,407.283L622.151,371.649L749.284,119.527L809.617,113.627L831.732,339.759",
    style: {
      fill: "rgb(255,175,172)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(256.673,0,0,355.367,40.764,292.51)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(195,214,202)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(203,209,198)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,175,172)",
      stopOpacity: 1
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.26d9fef746eba736e7b5fdf689b1bb8a.svg";